import { Grid, Paper } from '@mui/material';
import { useSnackbar } from 'notistack';
import { SubmitHandler } from 'react-hook-form';
import { useMutation } from 'react-query';
import { useNavigate, useParams } from 'react-router';
import * as api from '../../api/app/emailReportUserApi';
import { PageContent } from '../../components/core/PageContent/PageContent';
import { PageHeader } from '../../components/core/PageHeader/PageHeader';
import { EmailReportUserInputs } from '../../types/app/emailReportUser.types';
import { dictionary } from '../../utils/core/dictionary';
import { convertDataFromInputToCreateRequest } from '../../utils/core/functions/emailReportUser.functions';
import { paths } from '../../utils/core/routes';
import { EmailReportUserForm } from './EmailReportUserForm';
import { useStyles } from './EmailReportUserForm.styles';

export function EmailReportUserCreate() {
  const classes = useStyles();
  const { parentId } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { mutate: mutateCreateEmailReport } = useMutation(api.createEmailReportUser);

  const handleOnSubmit: SubmitHandler<EmailReportUserInputs> = (data: EmailReportUserInputs) => {
    const requestData = convertDataFromInputToCreateRequest({
      ...data,
      emailReportId: Number(parentId),
    });
    mutateCreateEmailReport(
      { ...requestData },
      {
        onSuccess: () => {
          enqueueSnackbar(dictionary.EMAIL_REPORT_CREATED, { variant: 'success' });
          navigate(`${paths.EMAIL_REPORT_DETAIL}/${Number(parentId)}`);
        },
        onError: (result: any) => {
          enqueueSnackbar(`${result}`, { variant: 'error' });
        },
      },
    );
  };

  return (
    <>
      <PageHeader title={dictionary.EMAIL_REPORT_CREATE} />
      <PageContent>
        <Grid container spacing={1}>
          <Grid item xs={12} md={8} lg={4}>
            <Paper className={classes.paper}>
              <EmailReportUserForm
                onSubmit={handleOnSubmit}
                onBack={() => navigate(`${paths.EMAIL_REPORT_DETAIL}/${Number(parentId)}`)}
              />
            </Paper>
          </Grid>
        </Grid>
      </PageContent>
    </>
  );
}
